import { BinaryFrame, FrameType } from './protocol';

/** Reference-dependent deltas may only follow a contiguous chain starting with an IDR. */
export class VideoSequenceGate {
  private expected: number | null = null;
  private recoveryRequested = false;
  constructor(private readonly requestRecovery: () => void) {}
  reset(): void { this.expected = null; this.recoveryRequested = false; }
  accept(frame: BinaryFrame): boolean {
    if (frame.type === FrameType.KEYFRAME) {
      this.expected = (frame.sequenceNumber + 1) >>> 0;
      this.recoveryRequested = false;
      return true;
    }
    if (frame.type !== FrameType.P_FRAME) return false;
    if (this.expected === null || frame.sequenceNumber !== this.expected) {
      this.expected = null;
      if (!this.recoveryRequested) {
        this.recoveryRequested = true;
        this.requestRecovery();
      }
      return false;
    }
    this.expected = (frame.sequenceNumber + 1) >>> 0;
    return true;
  }
}
